/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressFromKYC } from './address-from-kyc';
import { Address } from './address';
import { UserPhone } from './user-phone';
import { DealflowFile } from './dealflow-file';
import { CustomerStatusEnum } from './customer-status-enum';
import { TestStatusEnum } from './test-status-enum';
import { PEPSimple } from './pep-simple';

export interface DeckUserDetail {
  readonly id: string;
  readonly first_name: string;
  readonly last_name: string;
  readonly email: string;
  readonly date_joined: string;
  readonly sum_investment: number;
  readonly current_year_investment: number;
  readonly last_year_investment: number;
  readonly customer_status: CustomerStatusEnum;
  readonly customer_status_explanation: string | null;
  readonly kyc_test_status: TestStatusEnum;
  readonly primary_phone: string;
  readonly is_admin: boolean;
  readonly declared_in_kyc: string;
  readonly pep_status: boolean | null;
  readonly dealflow_files: Array<DealflowFile>;
  readonly phones: Array<UserPhone>;
  readonly login_type: Array<string>;
  readonly address_from_kyc: AddressFromKYC;
  readonly address: Address;
  readonly ct_test_status: TestStatusEnum;
  readonly pep_data: PEPSimple;
}
export namespace DeckUserDetail {}
